/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 11/4/20
 * Time: 11:50 PM
 */
import React, {Component} from 'react';
import {Card, CardBody, CardHeader} from "reactstrap";
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import {Button as SementicBtn} from "semantic-ui-react";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import * as tableHeaders from '../../../const/table/TableHeaders';
// import MapView from "../../Corporate/Branches/MapView/MapView";
import {geocodeByAddress, getLatLng} from "react-places-autocomplete";
import QRCode from "qrcode";
import * as keys from "../../../const/key/Key";
import {Icon, Spin, Tooltip} from "antd";
import Download from "../../../components/Button/DownloadbleButton";
import * as routeConstants from "../../../const/route/Route";

class App extends Component {
  state = {
    isMap: false,
    branch_list: [],
    // location details
    location: '',
    latLng: null, qrIamge: null, selectBranch: '', isSpin: false
  };
  changeSpinner = (isSpin) => {
    this.setState({isSpin})
  };
  getAllBranch = () => {
    const headers = {"Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)};
    this.changeSpinner(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporates[0].corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            branch_list: response.data.branchList
          })
        } else {
          this.setState({
            branch_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });
  };
  generateQR = (obj) => {
    this.props.spinnerHandler(true);

    QRCode.toDataURL(`${routeConstants.VISITOR_BRNACH_QR_URL}${obj.branchId}`.toString(), {scale: 10})
      .then(url => {
        this.setState({qrIamge: url, selectBranch: obj.name});
      })
      .catch(err => {
        console.error(err)
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };
  viewLocation = (location) => {
    geocodeByAddress(location)
      .then(results => getLatLng(results[0]))
      .then(latLng => this.setState(
        {latLng: latLng, isMap: true, location_: location}
      ))
      .catch(error => common.notifyMessage(error));
  };
  viewMap = () => {
    this.setState({
      isMap: !this.state.isMap,
    })
  };
  viewQRCode = (b64Code) => {
    let result = common.getB64ToBlob(b64Code);
    window.open(result, '_blank');
  };

  componentDidMount() {
    this.getAllBranch();
  }

  render() {
    let {isSpin, branch_list} = this.state;
    const rows = [];
    let downloadList = [];
    if (branch_list.length !== 0) {
      branch_list.map((row, index) => {
        rows.push(
          {
            name: row.name,
            address: row.address,
            // location: row.location,
            subscription: row.subscriptionNumber,
            // viewlocation: <SementicBtn icon='map marker alternate' circular color={"teal"}
            //                            onClick={e => this.viewLocation(row.location)}/>,
            building_count: row.buildings.length,
            qr_code: row.buildings.length > 0 ? <SementicBtn color={"teal"} circular icon='qrcode' onClick={e => this.generateQR(row)}/>:null
          }
        );
        downloadList.push({name: row.name,address: row.address,subscription: row.subscriptionNumber,buildingCount: row.buildings.length})
      });
    }

    let table_data = {columns: tableHeaders.hrViewBranchColumns, rows};

    return (
      <div>
        {/*{*/}
          {/*this.state.isMap ?*/}
            {/*<MapView location={this.state.location_} latLng={this.state.latLng} closeModal={this.viewMap}/> : null*/}
        {/*}*/}
        {
          this.state.qrIamge ?
            <MDBModal isOpen={true} toggle={() => {
            }} size="md" side position="top-right" className={"qr-code-branch"}>
              <MDBModalHeader className={"title-location"}
                              toggle={() => this.setState({qrIamge: null})}>{this.state.selectBranch}</MDBModalHeader>
              <MDBModalBody style={{padding: '0px'}}>
                <img src={this.state.qrIamge} style={{border: "5px solid rgba(255, 0, 0, 0.5)"}}
                     className="image-qr-branch"/>

                <div className={"qr-btn-branch"}>
                  <a className={"view-qr-btn"} onClick={() => this.viewQRCode(this.state.qrIamge)}>View QR
                    Code</a>
                  <a className={"view-qr-btn"} target={"_blank"} href={this.state.qrIamge} download={"QR code_"+this.state.selectBranch+".png"}>Download
                    QR Code</a>
                </div>
              </MDBModalBody>
            </MDBModal> : null
        }
        <Card>
          <CardHeader>
            All Branches
            <div className={"align-right filter-btn-second"}>
              <Tooltip placement="topLeft" title="Refresh">
                <SementicBtn onClick={this.getAllBranch} circular icon='refresh'/>
              </Tooltip>
            </div>
            <Download data={downloadList} userType={"RMV_BUILDING"} filename={"all-branches.csv"}/>
          </CardHeader>
          <CardBody className={"hr-branch-tbl"}>
            <Spin spinning={isSpin} delay={10}
                  indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
              <MDBDataTable
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
